export const route = {
    patterns: { settings: '/settings' },
    searchParams: { deletingAccount: 'deletingAccount', openPrivacyStatement: 'openPrivacyStatement' },
};
